import { render, staticRenderFns } from "./trainProgram.vue?vue&type=template&id=1ecf3dce&"
import script from "./trainProgram.vue?vue&type=script&lang=js&"
export * from "./trainProgram.vue?vue&type=script&lang=js&"
import style0 from "./trainProgram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports